import { useQuery } from "@tanstack/react-query";
import useFcmCounts from "@/hooks/fcm/use-fcm-counts";
import { ConversationControllerApi } from "@/services";
import { getConfigObject, getXtenantId } from "@/utils/utils";

interface Props {
  providerId?: string;
}

/**
 * Total unread chat messages for the provider across all conversations; seeds the Chat tab badge.
 */
export const useGetUnreadChatCount = ({ providerId }: Props) => {
  const [, setChatCount] = useFcmCounts("chat");

  return useQuery({
    queryKey: ["chat-unread-count", providerId],
    enabled: !!providerId,
    refetchOnWindowFocus: false,
    queryFn: async () => {
      const res = await new ConversationControllerApi(
        getConfigObject()
      ).getUnreadMessageCount(providerId!, getXtenantId());
      const unreadCount = Number(res?.data?.data ?? 0);

      setChatCount("chat", unreadCount);

      return unreadCount;
    },
  });
};
